import React, { useEffect, useState, useRef } from 'react';
import { useWebSocket } from '../../../context/WebSocketContext.jsx';
import axios from "../../../axiosInstance.js";
import icon7 from '../../../Assets/crane/icon7.svg'
import rightarrow from '../../../Assets/navbar/right-arrow.svg'
import { ClipLoader } from 'react-spinners';
import SocialDistanceIcon from '@mui/icons-material/SocialDistance';
import PinDropIcon from '@mui/icons-material/PinDrop';
import MyLocationIcon from '@mui/icons-material/MyLocation';
import PrecisionManufacturingIcon from '@mui/icons-material/PrecisionManufacturing';
import AssistantDirectionIcon from '@mui/icons-material/AssistantDirection';
import PersonIcon from '@mui/icons-material/Person';
import { Info, Loader2 } from "lucide-react";
import { Download, Phone, SlidersHorizontal } from "lucide-react";
import { CreditCard } from 'lucide-react';
import { Wifi, Shield, X } from 'lucide-react';

import {
    IndianRupee,
    Clock,
    MapPin,
    Route,
    MoveRight,
    MoveLeft,
} from "lucide-react";
import { useNavigate } from 'react-router-dom';
import LoadingProgressBar from './LoadingProgressBar.jsx';
import { Alert } from '@mui/material';
import SuccessMessage from '../VendorResponsesCustomer/SuccessMessage.jsx';
import DummyMapFromOLA from '../../../Component/Customers/DummyMapFromOLA.jsx';
import HdfcPaymentButton from '../PaymentPage/HDFCPaymentButton.jsx';
import SearchingContent from '../../../Component/SearchingContent.jsx';
import SelectPaymentGateway from '../PaymentPage/SelectPaymentGateway.jsx';

const customRound = (amount) => {
    const decimal = amount - Math.floor(amount);
    return decimal >= 0.5 ? Math.ceil(amount) : Math.floor(amount);
}

const ContactingServiceCard = ({
    isLoading = true,
    minEstimatedDuration,
    trackRepeatedRequests,
    setChooseFromSelectedServiceFinal,
    maxEstimatedDuration,
    minEstimatedAmount,
    maxEstimatedAmount,
    driverName,
    handleSubmit,
    exactTime,
    exactCost,
    setIsLoading,
    incomingAccidentVehicleCode,
    getVendorsWithLocation,
    getVendorsWithLocationForFlatBed,
    setCurrentStep,

}) => {
    const currentService = localStorage.getItem('currentService');
    const accidentDataObjectFromLocalStorage = localStorage.getItem('accidentDataObject');
    let chooseFromSelectedServiceFinal = null;

    if (accidentDataObjectFromLocalStorage) {
        const parsed = JSON.parse(accidentDataObjectFromLocalStorage);
        chooseFromSelectedServiceFinal = parsed.chooseFromSelectedServiceFinal;
    }

    // Source of truth for which case this screen shows: either handed down
    // fresh from AddVehicles (incomingAccidentVehicleCode — set on submit,
    // or on an explicit resume) or, failing that, whatever was last
    // confirmed in localStorage. Nothing in this file reads
    // AccidentVehicleCodeForTemp anymore — see getData() and
    // cancelingOrder() below.
    const [accidentVehicleCode, setAccidentVehicleCode] = useState(
        localStorage.getItem('AccidentVehicleCode') || incomingAccidentVehicleCode
    );

    const { messages, setMessages } = useWebSocket();

    const navigate = useNavigate()
    const token = localStorage.getItem("token");
    const userId = localStorage.getItem("userId");
    const [doneFetching, setDoneFetching] = useState(false)
    const [isGettingDataFronBackend, setIsGettingDataFronBackend] = useState(false)

    const [driversNotResponded, setDriversNotResponded] = useState(false)
    const [hasShownRetry, setHasShownRetry] = useState(false);
    const [isCancellingLoder, setIsCancellingLoader] = useState(false);
    const [showPopup, setShowPopup] = useState(false);
    const callContainerRef = useRef(null);

    const [selectedReasons, setSelectedReasons] = useState([]);
    const [otherReason, setOtherReason] = useState("");
    const [alertInfo, setAlertInfo] = useState({ show: false, message: '', severity: 'info' });

    const [alreadyCancelled, setAlreadyCancelled] = useState(false);

    const [data, setData] = useState([]);
    const [comingLink, setComingLink] = useState([])
    const didShowRetryOnce = useRef(false);
    const [showDetails, setShowDetails] = useState(false);
    const [timesUp, setTimesUp] = useState(false);
    const [retryForPayment, setRetryForPayment] = useState(0);
    const [isCancelContainerVisible, setIsCancelContainerVisible] = useState(false);
    const [reasonsForDrop, setReasonsForDrop] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");

    const [vendorsTimesUp, setVendorsTimesUp] = useState(false);

    const [timeLeft, setTimeLeft] = useState(0);
    const [retryStartTime, setRetryStartTime] = useState(null);
    const [cancelled, setCancelled] = useState(false);

    const [currentItem, setCurrentItem] = useState({})
    const [loadingForDownload, setLoadingForDownload] = useState(false);

    const handleDownload = async () => {
        setLoadingForDownload(true);
        try {
            const response = await axios.put(
                `${process.env.REACT_APP_BACKEND_URL}/api/generateEstimatePDF/${data?.[0]?.[`${currentService}Details`]?.CustomerCode}/${data?.[0]?.[`${currentService}Details`]?.AccidentVehicleCode}`
            );

            const estimateUrl = response.data.data;
            if (typeof estimateUrl === 'string' && estimateUrl.startsWith('http')) {
                const link = document.createElement('a');
                link.href = estimateUrl;
                const formattedType = chooseFromSelectedServiceFinal.replace(/^./, (c) =>
                    c.toUpperCase()
                );
                link.download = `${formattedType}.docx`;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            } else {
                alert("Download link not available.");
            }
        } catch (err) {
            console.error("Failed to generate/download estimate:", err);
            alert("Something went wrong while downloading the estimate.");
        } finally {
            setLoadingForDownload(false);
        }
    };


    useEffect(() => {
        const handleClickOutside = (event) => {
            if (callContainerRef.current && !callContainerRef.current.contains(event.target)) {
                setShowPopup(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    const intervalRef = useRef(null);

    useEffect(() => {
        const totalDuration = 90 * 60 * 1000; // 90 minutes
        const autoCancelDuration = 80 * 60 * 1000; // 80 minutes

        const vendorConnectedTimeStr = data?.[0]?.[`${currentService}Details`]?.connectedVendorFullyTime;

        if (!vendorConnectedTimeStr) return;

        const vendorConnectedTime = new Date(vendorConnectedTimeStr).getTime();

        const updateTimer = () => {
            const now = Date.now();
            const timeElapsed = now - vendorConnectedTime;
            const timeLeft = Math.floor((totalDuration - timeElapsed) / 1000);

            if (timeLeft <= 0) {
                setTimeLeft(0);
                setTimesUp(true);
            } else {
                setTimeLeft(timeLeft);
            }

            if (timeElapsed >= autoCancelDuration) {
                const reason = "Timed-out";
                setSelectedReasons(reason);
                cancelingOrder(currentItem, [reason]);
                clearInterval(intervalRef.current);
            }
        };

        intervalRef.current = setInterval(updateTimer, 1000);
        updateTimer();

        return () => {
            clearInterval(intervalRef.current);
        };
    }, [doneFetching, data]);



    const radius = 50 / 2;
    const stroke = 2;
    const normalizedRadius = radius - stroke * 0.5;
    const circumference = 2 * Math.PI * normalizedRadius;
    const strokeDashoffset = circumference - (timeLeft / 6000) * circumference;

    const formatTime = (seconds) => {
        const mins = Math.floor(seconds / 60);
        const secs = seconds % 60;
        return `${String(mins).padStart(2, '0')}:${String(secs).padStart(2, '0')}`;
    };


    const toggleDetails = () => {
        setShowDetails(!showDetails);
    };

    useEffect(() => {
        if (vendorsTimesUp && !doneFetching) {
            setDriversNotResponded(true);
            localStorage.setItem('currentStep', "05")
            sessionStorage.setItem('hasRetriedOnce', 'true');
        }
    }, [vendorsTimesUp])


    const alreadyRetried = sessionStorage.getItem('hasRetriedOnce');
    useEffect(() => {
        if (messages.length > 0) {
            messages.forEach((message) => {
                if (message.forPage === 'quotation-updates-crane-for-rejection' && alreadyRetried == 'false') {
                    setDriversNotResponded(true);
                    sessionStorage.setItem('hasRetriedOnce', 'true');
                }

                if (message.forPage === 'quotation-updates-crane') {
                    getData();
                }
            });

            setMessages([]);
        }
    }, [messages]);

    // Fetches as soon as we know which case this is — whether that code
    // arrived via a fresh submission or an explicit resume from the
    // homepage. Nothing here polls on its own; it only reacts to
    // accidentVehicleCode changing.
    useEffect(() => {
        if (accidentVehicleCode) {
            setIsGettingDataFronBackend(true);
            getData();
        }
    }, [accidentVehicleCode]);


    const cancleCaseProcedureFunc = (item) => {
        setIsCancelContainerVisible(true)
        setReasonsForDrop(false)
    }

    const reasons = [
        "Too much time taking",
        "Got Other Services",
        "Not Needed Now", "Changed my mind"
    ];

    const handleSelectReason = (reason) => {
        if (selectedReasons.includes(reason)) {
            setSelectedReasons(selectedReasons.filter((item) => item !== reason));
        } else {
            setSelectedReasons([...selectedReasons, reason]);
        }
    };


    const getData = async (e) => {
        const codeToUse = accidentVehicleCode || localStorage.getItem('AccidentVehicleCode');
        if (!codeToUse) {
            setDoneFetching(true);
            setData([]);
            setIsGettingDataFronBackend(false);
            return;
        }

        const url = `${process.env.REACT_APP_BACKEND_URL}/api/getParticularAccidentVehicleById/${userId}/${currentService}/${codeToUse}`;
        const responseFromID = await axios.get(url, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });

        if (responseFromID.data.message === "No accident vehicle data found.") {
            setDoneFetching(true)
            setData([])
            setIsGettingDataFronBackend(false)
            return;
        }

        const row = responseFromID.data.data[0];
        // doneFetching means "a vendor has connected" — not "the fetch
        // succeeded". Deriving it from connectedVendorFully (the same
        // column the resume endpoint uses) keeps this screen and the
        // resume/list endpoint agreeing on the same signal, so resuming
        // into "still finding a partner" doesn't jump straight to payment.
        const vendorConnected = Boolean(row?.[`${currentService}Details`]?.connectedVendorFully);

        setData(responseFromID.data.data);
        localStorage.setItem('AccidentVehicleCode', codeToUse);
        setCurrentItem(row);
        localStorage.setItem('paymentDetails', JSON.stringify(row));

        setDoneFetching(vendorConnected);
        setIsGettingDataFronBackend(false);
        if (vendorConnected) setOpenPaymentModal(true);
    };


    const cancelingOrder = async (currentItem, passedReasons = []) => {
        try {
            const reasons = [...passedReasons, selectedReasons, otherReason].filter(Boolean);
            if (reasons.length === 0) {
                return setAlertInfo({ show: true, message: 'Select Respective Reason', severity: 'error' });
            }

            const codeToUse = accidentVehicleCode || localStorage.getItem('AccidentVehicleCode');
            let url = doneFetching == false
                ? `${process.env.REACT_APP_BACKEND_URL}/api/cancellingOrderPrimaryStage/${codeToUse}/${currentService}/${userId}`
                : `${process.env.REACT_APP_BACKEND_URL}/api/cancellingOrderSecondaryStage/${currentItem?.[`${currentService}Details`].AccidentVehicleCode}/${currentService}/${userId}/${currentItem[`${currentService}Details`][`${currentService}`]}/${currentItem?.[`${currentService}Details`].vehicleNo}`;

            const response = await axios({
                method: "PUT",
                url: url,
                headers: {
                    'Authorization': `Bearer ${token}`
                },
                data: {
                    cancleOrderReason: [...selectedReasons, otherReason]
                }
            });

            if (response.data.status === true) {
                setIsCancelContainerVisible(false);
                setReasonsForDrop(false);
                setCancelled(true)

                const keepKeys = [
                    "iconify-version",
                    "iconify-count",
                    "token",
                    "userId",
                    "loginId",
                    "loginTime",
                    "userRole",
                    "fromLogin",
                    "justLoggedIn",
                    "gps_location",
                    "currentService"
                ];

                Object.keys(localStorage).forEach((key) => {
                    if (!keepKeys.includes(key)) {
                        localStorage.removeItem(key);
                    }
                });
                navigate('/customer-home-page')
            } else {
                setAlreadyCancelled(true);
            }
        } catch (error) {
            console.error("Error canceling order:", error);
        }
    };

    const [openPaymentModal, setOpenPaymentModal] = useState(false);


    return (
        <div className="font-satoshi min-h-screen bg-white flex flex-col items-center justify-start">
            {cancelled == false && (
                <div className="w-full h-full flex-grow rounded-2xl shadow-lg overflow-hidden border border-gray-200">
                    {/* Map and Car */}
                    <div className="relative h-[calc(100vh - 22em)] w-full bg-gray-200 flex items-center justify-center">
                        <DummyMapFromOLA />
                        <div className="absolute top-6 text-center text-white text-sm bg-[#21A6E9] px-3 py-1 rounded-full shadow-md">{!doneFetching ? "Waiting For Driver" : "Payment"}</div>
                        {!doneFetching && (<div className="absolute inset-0 flex items-center justify-center">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" width="150" height="150">
                                <g fill="none" stroke="#1770AD" strokeWidth="2">
                                    <circle cx="22" cy="22" r="1">
                                        <animate attributeName="r" values="1; 20" dur="1.8s" repeatCount="indefinite" />
                                        <animate attributeName="stroke-opacity" values="1; 0" dur="1.8s" repeatCount="indefinite" />
                                    </circle>
                                    <circle cx="22" cy="22" r="1">
                                        <animate attributeName="r" values="1; 20" dur="1.8s" begin="0.9s" repeatCount="indefinite" />
                                        <animate attributeName="stroke-opacity" values="1; 0" dur="1.8s" begin="0.9s" repeatCount="indefinite" />
                                    </circle>
                                </g>
                            </svg>
                        </div>)}
                    </div>

                    {!doneFetching && (
                        <div className="font-satoshi bg-white p-4 space-y-3 mb-[4rem]">
                            <LoadingProgressBar setVendorsTimesUp={setVendorsTimesUp} vendorsTimesUp={vendorsTimesUp} />
                            <div className="text-gray-700 font-semibold text-sm flex  align-center justify-center">
                            </div>

                            <div className="text-gray-700 font-semibold text-sm flex mb-2 align-center justify-center">
                                <div className="text-gray-500 text-xs">Please wait while we are confirming your request</div>
                            </div>

                            <div style={{ marginTop: '2rem' }} className="relative w-full border border-gray-300 rounded-xl px-3 py-2 mb-3">
                                <div className="absolute -top-3 left-4 bg-red-200 px-2 py-1 rounded-lg text-xs font-semibold border border-gray-300 animate-pulse shadow-md">
                                    Estimated
                                </div>
                                <div className="text-sm text-gray-700 font-semibold flex justify-between mt-4">
                                    <span>Duration</span>
                                    <span>{localStorage.getItem('minDuration')} - {localStorage.getItem('maxDuration')}</span>
                                </div>
                                <div className="flex justify-between text-sm font-semibold text-gray-700 mt-1">
                                    <span>Amount</span>
                                    <span>
                                        ₹ {localStorage.getItem('maxAmount')}
                                    </span>
                                </div>
                            </div>

                            {alreadyRetried == 'false' && (
                                <div className="flex justify-center w-full fixed bottom-0 left-0 right-0 z-[10] ">
                                    <div className=" flex items-center justify-between bg-white p-2 rounded-t-xl w-full  gap-[0.5rem] mx-auto md:rounded-none md:p-0 md:bg-transparent">

                                        <button
                                            className="mt-[1rem] w-full py-3 bg-gray-300 text-gray-500 rounded-lg font-semibold cursor-not-allowed backdrop-blur-md"
                                            disabled
                                        >
                                            Proceed to Pay
                                        </button>
                                        <button
                                            onClick={cancleCaseProcedureFunc}
                                            className="mt-[1rem] w-full py-3 bg-red-400 text-white rounded-lg font-semibold cursor-not-allowed backdrop-blur-md"
                                        >
                                            Cancel Request
                                        </button>

                                        <div className="font-satoshi relative inline-block" ref={callContainerRef}>
                                            {showPopup && (
                                                <div className="absolute bottom-10 right-10 bg-white border rounded shadow-md p-3 z-50 w-[40vw]">
                                                    <p className="text-sm mb-2 text-gray-700">Need help?</p>
                                                    <a
                                                        href="tel:+917800784700"
                                                        className="flex items-center gap-2 text-blue-600 hover:text-blue-800"
                                                    >
                                                        <Phone size={20} className='text-blue-400 font-bold' />
                                                        <p className='text-blue-500 font-bold font-400'>Call Us</p>
                                                    </a>
                                                </div>
                                            )}
                                            <button
                                                className="text-blue-500 hover:text-blue-700 mt-[1rem]"
                                                onClick={() => setShowPopup((prev) => !prev)}
                                            >
                                                <Info size={24} />
                                            </button>
                                        </div>

                                        <div className="flex-grow max-w-[5rem] min-w-[1rem]"></div>

                                    </div>
                                </div>
                            )}

                            {alreadyRetried == 'true' && (
                                <div>
                                    <div className="flex justify-center fixed bottom-0 left-0 right-0 z-[10] ">
                                        <div className=" flex items-center justify-between bg-white p-2 mb-[1rem] rounded-t-xl w-full gap-[0.5rem] mx-auto md:rounded-none md:p-0 md:bg-transparent">
                                            <button
                                                onClick={() => {
                                                    localStorage.removeItem('progressStartTime');
                                                    setDriversNotResponded(false);
                                                    setChooseFromSelectedServiceFinal(null)
                                                    setIsLoading(true);
                                                    setCurrentStep('04');
                                                    currentService == 'recoveryVan' ? getVendorsWithLocationForFlatBed(trackRepeatedRequests) : getVendorsWithLocation(trackRepeatedRequests);;
                                                }}
                                                style={{ border: '3px solid green' }}
                                                className="mt-1 w-full py-3 bg-white text-green-800 rounded-lg font-semibold"
                                            >
                                                Retry Again...
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            )}

                            {alreadyRetried == 'false' ? (<div className="flex items-center justify-center text-sm">
                                <SearchingContent />
                            </div>) : (
                                <div className="flex items-center  justify-center text-sm">
                                    <span className="text-red-500  text-xs">We were almost there please retry!</span>
                                </div>
                            )}

                        </div>
                    )}

                    {/* Details Card */}
                    {doneFetching && (
                        <div className="bg-white p-4 space-y-3">

                            <div className="flex items-center justify-between text-sm">
                                <div className="text-[#21A6E9] text-xs font-medium">Make Payment Within Time</div>
                                <div className="flex items-center space-x-4">
                                    <div className="flex justify-center items-center " style={{
                                        background: 'transparent',
                                        height: `${50}px`,
                                        width: `${50}px`,
                                    }}>
                                        <svg height={radius * 2} width={radius * 2}>
                                            <circle
                                                stroke="#2c2f3b"
                                                fill="transparent"
                                                strokeWidth={stroke}
                                                r={normalizedRadius}
                                                cx={radius}
                                                cy={radius}
                                            />
                                            <circle
                                                stroke="#EFF9FD"
                                                fill="transparent"
                                                strokeWidth={stroke}
                                                strokeLinecap="round"
                                                strokeDasharray={circumference + ' ' + circumference + ' ' + circumference}
                                                strokeDashoffset={strokeDashoffset}
                                                r={normalizedRadius}
                                                cx={radius}
                                                cy={radius}
                                                style={{ transition: 'stroke-dashoffset 1s linear' }}
                                            />
                                            <text
                                                x="50%"
                                                y="50%"
                                                dominantBaseline="middle"
                                                textAnchor="middle"
                                                fill="red"
                                                fontSize="13px"
                                                fontWeight="bold"
                                                className='font-satoshi animate-pulse shadow-md'
                                            >
                                                {formatTime(timeLeft)}
                                            </text>
                                        </svg>
                                    </div>
                                </div>
                            </div>

                            <div style={{ marginTop: '1rem', border: '1px solid green' }} className="relative w-full rounded-xl px-3 py-2 mb-3">
                                <div className="absolute -top-3 left-4 bg-red-200 px-2 py-1 rounded-lg text-xs font-semibold border border-gray-300 animate-pulse shadow-md">
                                    Final Details
                                </div>
                                <div className="text-sm text-gray-700 font-semibold flex justify-between mt-4">
                                    <span>Distance</span>
                                    <span>{Number(data?.[0]?.[`${currentService}Details`]?.totalDistance).toFixed(2)} KM</span>
                                </div>
                                <div className="flex justify-between text-sm font-semibold text-gray-700 mt-1">
                                    <span>Duration</span>
                                    <span>
                                        {data?.[0]?.[`${currentService}Details`]?.totalDuration}
                                    </span>
                                </div>
                                <div className="text-sm text-gray-700 font-semibold flex justify-between mt-1">
                                    <span>Cost Estimation</span>
                                    <span>
                                        {loadingForDownload ? (
                                            <Loader2 className="animate-spin text-blue-500 h-[1rem] mt-[0.3rem]" />
                                        ) : (
                                            <Download
                                                onClick={handleDownload}
                                                className="text-blue-500 cursor-pointer h-[1rem] mt-[0.3rem]"
                                            />
                                        )}
                                    </span>
                                </div>
                            </div>

                            <div className="mt-4 space-y-4 pb-[6rem]">
                                <div style={{ marginTop: '1rem' }} className="flex items-center space-x-4 ">
                                    <MyLocationIcon className="text-gray-700" />
                                    <div>
                                        <p className="text-sm">{data?.[0]?.[`${currentService}Details`]?.pickupLocation}</p>
                                        <p className="text-xs font-semibold">Spot Location</p>
                                    </div>
                                </div>
                                <div className="flex items-center space-x-4">
                                    <PinDropIcon className="text-gray-700" />
                                    <div>
                                        <p className="text-sm">{data?.[0]?.[`${currentService}Details`]?.dropLocation}</p>
                                        <p className="text-xs font-semibold">Drop Location</p>
                                    </div>
                                </div>
                            </div>
                            <div className="flex justify-center fixed bottom-20 left-0 right-0 z-[20] pointer-events-none">
                                <div className="flex items-center justify-end bg-white pb-4 px-4 rounded-t-xl w-full gap-2 mx-auto md:rounded-none md:p-0 md:bg-transparent pointer-events-auto">
                                    <h2 className="text-xl font-semibold">
                                        ₹ {data?.[0]?.[`${currentService}Details`]?.charges}
                                    </h2>
                                </div>
                            </div>

                            {!timesUp && (
                                <div className="flex justify-center fixed bottom-0 left-0 right-0 z-[30] ">
                                    <div className=" flex items-center justify-between bg-white p-2 rounded-t-xl w-full gap-[0.5rem] mx-auto md:rounded-none md:p-0 md:bg-transparent">
                                        <button
                                            onClick={() => { setOpenPaymentModal(true) }}
                                            className='mt-[1rem] min-w-[50vw] py-4 bg-[#21A6E9] text-white rounded-lg font-semibold flex items-center justify-center gap-2'
                                        >
                                            Proceed for Payment
                                        </button>

                                        <button
                                            onClick={cancleCaseProcedureFunc}
                                            className="mt-[1rem] w-full py-4 bg-red-400 text-white rounded-lg font-semibold cursor-not-allowed backdrop-blur-md"
                                        >
                                            Cancel
                                        </button>
                                        <div
                                            onClick={() => (window.location.href = 'tel:+917800784700')}
                                            className="bg-gray-100 mt-3 rounded-full p-3">
                                            <Phone className="text-black" />
                                        </div>
                                    </div>
                                    {openPaymentModal && (
                                        <div className="fixed inset-0 bg-[#0000008c] p-2 bg-opacity-40 flex justify-center items-center z-[999]">
                                            <div className="bg-white rounded-2xl shadow-xl w-full max-w-xl p-6 relative">
                                                <button
                                                    onClick={() => { setOpenPaymentModal(false) }}
                                                    className="absolute top-4 right-4 text-gray-500 hover:text-red-500 transition"
                                                >
                                                    <X className="w-6 h-6" />
                                                </button>

                                                <h2 className="text-1xl font-bold text-[#21a6e9] mb-6">
                                                    Cost Breakdown
                                                </h2>

                                                <div className="space-y-4 text-sm sm:text-base">
                                                    <div className="flex justify-between text-gray-600 border-b pb-2">
                                                        <span> Amount</span>
                                                        <span>₹ {customRound(parseFloat(data?.[0]?.[`${currentService}Details`]?.nonGSTCharge)).toFixed(2)}</span>
                                                    </div>
                                                    <div className="flex justify-between text-gray-600 border-b pb-2">
                                                        <span>Platform Charges</span>
                                                        <span >₹ {(
                                                            parseFloat(data?.[0]?.[`${currentService}Details`]?.platformCharge)
                                                        ).toFixed(2)}</span>
                                                    </div>

                                                    <div className="flex justify-between text-gray-600 border-b pb-2">
                                                        <span>Other Charges (if any)</span>
                                                        <span>₹ 0.00</span>
                                                    </div>

                                                    <div className="flex justify-between text-gray-800">
                                                        <span>GST (@18%)</span>
                                                        <span>₹ {(parseFloat(data?.[0]?.[`${currentService}Details`]?.gstCharges)).toFixed(2)}</span>
                                                    </div>
                                                    <div className="flex justify-between font-semibold text-gray-800">
                                                        <span>Estimated</span>
                                                        <span>₹ {(parseFloat(data?.[0]?.[`${currentService}Details`]?.estimatedAmount)).toFixed(2)}</span>
                                                    </div>
                                                    <div className="flex justify-between font-semibold text-gray-800">
                                                        <span>Round-off</span>
                                                        <span>₹ {(parseFloat(data?.[0]?.[`${currentService}Details`]?.roundOff)).toFixed(2)}</span>
                                                    </div>
                                                    <hr />

                                                    <div className="flex justify-between font-bold text-lg text-[#21a6e9] border-t mt-3">
                                                        <span>Payable Amount</span>
                                                        <span>₹ {(parseFloat(data?.[0]?.[`${currentService}Details`]?.charges)).toFixed(2)}
                                                        </span>
                                                    </div>
                                                </div>
                                                <div className="flex justify-center mt-6">
                                                    <button className="mt-[1rem] w-full py-4 bg-[#21A6E9] text-white rounded-lg font-semibold flex items-center justify-center gap-2" disabled={timesUp} onClick={() => navigate('/select-payment-gateway', { state: { data, currentService } })}>
                                                        Proceed To Payment
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            )}

                            {timesUp && retryForPayment < 3 && (
                                <div className="flex justify-center fixed bottom-0 left-0 right-0 z-[10] ">
                                    <div className=" flex items-center justify-between bg-white p-2 rounded-t-xl w-full max-w-[28rem] gap-[0.5rem] mx-auto md:rounded-none md:p-0 md:bg-transparent">
                                        <button onClick={() => {
                                            setRetryStartTime(Date.now());
                                            setTimeLeft(6000);
                                            setTimesUp(false);
                                            setRetryForPayment(prev => prev + 1);
                                        }} className="mt-4 w-full py-3 bg-red-300 text-white rounded-lg font-semibold">
                                            Times Up... Retry Again
                                        </button>
                                    </div>
                                </div>
                            )}

                            {retryForPayment == 3 && (
                                <div className="flex justify-center fixed bottom-0 left-0 right-0 z-[10] ">
                                    <div className=" flex items-center justify-between bg-white p-2 rounded-t-xl w-full max-w-[28rem] gap-[0.5rem] mx-auto md:rounded-none md:p-0 md:bg-transparent">
                                        <button onClick={() => {
                                            setDriversNotResponded(false)
                                            setIsLoading(true)
                                            setCurrentStep('04');
                                            currentService == 'recoveryVan' ? getVendorsWithLocationForFlatBed(trackRepeatedRequests) : getVendorsWithLocation(trackRepeatedRequests);
                                        }}
                                            className="mt-4 w-full py-3 bg-red-300 text-white rounded-lg font-semibold "
                                        >
                                            Times Up... Retry Again
                                        </button>
                                    </div>
                                </div>
                            )}

                        </div>)}

                    {isCancelContainerVisible && (
                        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[1000] mt-[40px]">
                            <div className="bg-white py-[42px] px-[30px] rounded-[30px] shadow-lg w-[90%] md:w-[536px] relative">
                                <h6 className="m-0 font-[700]  text-[30px] font-satoshi text-center text-[#000000]">Cancel Request</h6>
                                <img onClick={(e) => {
                                    setIsCancelContainerVisible(false)
                                    setReasonsForDrop(false)
                                    setSelectedReasons([])
                                    setOtherReason('')
                                }}
                                    src='https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/crane/icon7.svg' className='absolute top-[12px] right-[12px] h-[35px] w-[35px]' alt="" />
                                <div>
                                    {reasonsForDrop == false && (
                                        <div>
                                            <div className="flex flex-col justify-center items-center w-full mt-4">
                                            <p className="m-0 font-[700] font-satoshi text-[17px] sm:text-[24px] my-4 text-[#0A0119] pb-[6px]">We are almost there to get you perfect crane service!!! </p>
                                            <p className="m-0 font-[700] font-satoshi text-[17px] sm:text-[24px]  my-4 pb-[6px] text-[#EE3840]">Still want to opt-out❓ </p>
                                            </div>
                                            <div className=" grid md:grid-cols-2 grid-cols-1 pt-[20px] items-center gap-[18px] ">
                                                <div
                                                    onClick={(e) => {
                                                        setReasonsForDrop(false)
                                                        setIsCancelContainerVisible(false)
                                                        setSelectedReasons([])
                                                        setOtherReason('')
                                                    }}
                                                    className="bg-[#21A6E9] flex py-[5px] rounded-full pr-[6px] pl-[6px] w-full justify-between items-center cursor-pointer">
                                                    <img src='https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/navbar/right-arrow.svg' className='h-[30px] w-[30px] rotate-180' alt="" />
                                                    <button className="font-satoshi font-[400] text-[18px] leading-[33.6px] pr-[36px] text-[#FFFFFF]">Ready to wait</button>
                                                </div>
                                                <div onClick={() => setReasonsForDrop(true)} className="bg-[#EE3840] flex py-[5px] rounded-full pr-[6px] pl-[26px] w-full cursor-pointer justify-between items-center">
                                                    <button className="font-satoshi font-[400] text-[18px] leading-[33.6px] text-[#FFFFFF]">Cancel Request</button>
                                                    <img src='https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/navbar/right-arrow.svg' className='h-[30px] w-[30px]' alt="" />
                                                </div>
                                            </div>
                                        </div>)}

                                    {reasonsForDrop == true && (
                                        <div>
                                            <div>
                                                <div>
                                                    <div style={{ margin: "10px", marginTop: '20px', display: "flex", gap: "10px", flexWrap: "wrap" }}>
                                                        {reasons.map((reason) => (
                                                            <button
                                                                key={reason}
                                                                onClick={() => handleSelectReason(reason)}
                                                                style={{
                                                                    fontSize: '12px',
                                                                    display: "flex",
                                                                    justifyContent: "center",
                                                                    alignItems: "center",
                                                                    padding: "10px",
                                                                    borderRadius: "20px",
                                                                    backgroundColor: selectedReasons.includes(reason) ? "#21A6E9" : "white",
                                                                    color: selectedReasons.includes(reason) ? "white" : "black",

                                                                    border: "1px solid #21A6E9",
                                                                    cursor: "pointer",
                                                                    boxShadow: selectedReasons.includes(reason) ? "0 4px 8px rgba(0,0,0,1.2)" : "0 3px 6px rgba(0, 0, 0, 0.5)"
                                                                }}
                                                            >
                                                                {reason}
                                                            </button>
                                                        ))}
                                                    </div>

                                                    <label className="form-field" style={{ color: '#3f3c00', marginTop: '20px', fontSize: "14px" }}>
                                                        <p style={{ textAlign: "left", fontSize: '16px' }}> Other Reason  : </p>
                                                        <textarea
                                                            style={{ margin: "10px 10px 5px 0px", width: "280px" }} className="form-control" name="otherReason" value={otherReason} onChange={(e) => setOtherReason(e.target.value)} />
                                                    </label>

                                                    {errorMessage && <div style={{ color: "red", margin: "10px 10px 20px 10px", marginBottom: "10px" }}>{errorMessage}</div>}

                                                    <div className='pb-10'>
                                                        {isCancellingLoder && (
                                                            <div style={{ marginTop: '10px', display: "flex", justifyContent: "center", alignItems: 'center' }}>
                                                                <ClipLoader color="black" loading={isCancellingLoder} />
                                                                <div style={{ marginTop: '10px', color: 'black' }}> Please Wait...</div>
                                                            </div>
                                                        )}
                                                        {alreadyCancelled && (<div class="alert alert-danger" role="alert">
                                                            You have already Cancelled Case !!!
                                                        </div>)}
                                                        {alertInfo.show && (
                                                            <Alert severity={alertInfo.severity} onClose={() => setAlertInfo({ ...alertInfo, show: false })}>
                                                                {alertInfo.message}
                                                            </Alert>
                                                        )}

                                                        <div onClick={(e) => { cancelingOrder(currentItem) }} disabled={isCancellingLoder} className="bg-[#EE3840] flex py-[5px] rounded-full pr-[6px] pl-[26px] w-full cursor-pointer justify-between items-center">
                                                            <button className="font-satoshi font-[400] text-[18px] leading-[33.6px] text-[#FFFFFF]">Confirm Cancellation</button>
                                                            <img src='https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/navbar/right-arrow.svg' className='h-[30px] w-[30px]' alt="" />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                </div>

                            </div>
                        </div>
                    )}

                    {isGettingDataFronBackend && (
                        <div className="fixed inset-0 z-[9999] bg-white bg-opacity-80 flex items-center justify-center">
                            <div className="loader2 h-[50px] w-[20px]"></div>
                        </div>
                    )}

                </div >)}
            {cancelled == true && <SuccessMessage state={{ fromPage: 'contactingService' }} />}
        </div >

    );
};

export default ContactingServiceCard;